import React from "react";
import styled from "styled-components";

const ContentVideos = (props) => {
  const { videos } = props;
  return (
    <Container>
      {videos.map((video, index) => {
        return (
          <Body key={index}>
            <span>{index + 1}.</span> {video}
          </Body>
        );
      })}
    </Container>
  );
};

export default ContentVideos;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Body = styled.p`
  color: #616161;
  font-size: 0.95rem;
  span {
    font-weight: bold;
  }
  margin-top: 1rem;
`;
